
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as contact from '~/store/modules/contact'

import Phone from '~/components/Icons/Phone.vue'
import Mail from '~/components/Icons/Mail.vue'
import CircleBullet from '~/components/Icons/CircleBullet.vue'
import CheckIcon from '~/components/Icons/CheckIcon.vue'
import AddressBar from '~/components/Plans/AddressBar.vue'
import ValidationError from '~/components/ValidationError.vue'
import BuildingManagementProgramContactForm from '~/components/ContactForm/BuildingManagementProgram.vue'
import { ContactForm } from '~/lib/contact/ContactForms'

const Contact = namespace(contact.name)

@Component({
  head() {
    return {
      title: `Building Management Program - ${this.brand.name}`,
      meta: [
        {
          hid: 'Building Management Program',
          name: 'description',
          content: `Discover a Better Way with the Uniti Internet Building Management Program`
        }
      ]
    }
  },
  components: {
    BuildingManagementProgramContactForm,
    Mail,
    Phone,
    AddressBar,
    ValidationError,
    CircleBullet,
    CheckIcon
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class BuildingManagementProgram extends Vue {
  @Contact.Action
  create
  
  @Contact.Action
  validate

  error = false

  sending = false

  sent = false

  created() {
    if (!['uni'].includes(process.env.siteId)) {
      this.$router.push({ path: '/' })
    }
  }

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  }

  async handleSubmit(event: ContactForm) {
    try {
      this. sending = true
      const token = await this.$recaptcha.getResponse()
      await this.validate({...event, token})
      await this.$recaptcha.reset()
      await this.create(event)

      this.sending = false;
      this.sent = true;
    } catch(e: unknown) {
      this.error = true
    }
  }
}
